<template>
  <div class="password-box reg-box">
    <div class="title" v-if="role == 2">企业注册</div>
    <div class="input">
      <el-input
        class="btn-form"
        placeholder="请输入手机号"
        maxlength="11"
        tabindex="1"
        name="mobile"
        v-model="loginForm.mobile"
        clearable
      ></el-input>
    </div>
    <div class="input yanzm">
      <el-input
        class="btn-form"
        placeholder="短信验证码"
        maxlength="6"
        tabindex="3"
        name="smsCode"
        v-model="loginForm.smsCode"
      ></el-input
      ><el-button
        @click="sendYanzm"
        :disabled="yanzmDisabled"
        class="sendYanzm btn-form"
        type="text"
        >{{ yanzmStr }}</el-button
      >
    </div>
    <div class="input">
      <el-input
        class="btn-form"
        maxlength="20"
        @keyup.enter.native="loginHandler"
        placeholder="密码至少6位，包含大小写字母、数字"
        name="pwd"
        v-model="loginForm.pwd"
        tabindex="2"
        show-password
        clearable
      ></el-input>
    </div>
    <div class="viewDetail">
      <el-checkbox v-model="checked">
        我已阅读并同意 <secrect-control></secrect-control>
      </el-checkbox>
    </div>
    <div class="btns">
      <el-button class="btn" type="primary" @click="loginHandler()"
        >注 册</el-button
      >
    </div>
    <div class="user-reg">
      <a class="txt-btn" @click="goBackLogin()">直接登录</a>
    </div>

    <el-dialog
      class="btn-close"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <pre class="dialogHtml" v-html="dialogHtml"></pre>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >我知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { LOGIN_API,REPORT_API } from "@/api.js";
import { isMobile, isPwd } from '@/untils/validate'
import SecrectControl from '@/components/secrect'
export default {
  props: ['role'],
  data() {
    return {
      loginForm: {
        mobile: '',
        pwd: '',
        smsCode: '',
        randomStr: '',
        ticket: '',
      },
      confirm: {},
      checked: false,
      yanzmDisabled: false,
      yanzmTime: 60,
      yanzmStr: '发送验证码',
      dialogHtml: '',
      dialogTitle: '',
      dialogVisible: false,
    }
  },
  components:{SecrectControl},
  mounted() {},
  methods: {
    goBackLogin() {
      this.$emit('goBackLogin')
    },
    sendMsmHandler() {
      if (!this.loginForm.mobile) {
        this.$message.error('请输入手机号！')
        return
      }
      let post = {
        type: 2,
        ...this.loginForm,
      }
      let url = `${REPORT_API}/api/account/smscode`
      if (this.role == 1) {
        url = `${LOGIN_API}/customer/api/smscode`
      }
      this.$axios.post(url, post).then((res) => {
        if (this.role == 1) {
          if (res.data.errno == 0) {
            this.setTimer()
          } else {
            this.$message.error(res.data.errmsg)
          }
        } else {
          if (res.data.code == 0) {
            this.setTimer()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    setTimer() {
      this.$message.success('短信验证码发送成功！')
      this.yanzmDisabled = true
      this.yanzmTime = 60
      window.loginTimer ? window.clearInterval(window.loginTimer) : null
      window.loginTimer = window.setInterval(() => {
        this.yanzmTime--
        if (this.yanzmTime < 0) {
          this.yanzmDisabled = false
          window.clearInterval(window.loginTimer)
          this.yanzmStr = '发送验证码'
          return
        }
        this.yanzmStr = '验证码（' + this.yanzmTime + '秒）'
        console.log(this.yanzmStr)
      }, 1000)
    },
    callback(res) {
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      if (res && res.ret === 0) {
        this.loginForm.randomStr = res.randstr
        this.loginForm.ticket = res.ticket
        this.sendMsmHandler()
      }
    },
    sendYanzm() {
      if (!isMobile(this.loginForm.mobile)) {
        this.$message.error('亲，手机号格式不正确，请重试！')
        return
      }
      if (!this.loginForm.mobile) {
        this.$message.error('请输入手机号！')
        return
      }
      var captcha1 = new TencentCaptcha('2012913766', this.callback)
      captcha1.show()
    },
    loginHandler() {
      if (!this.checked) {
        this.$message.error('请勾选您已阅读相关注册协议！')
        return
      }
      if (!this.loginForm.mobile || !this.loginForm.pwd) {
        this.$message.error('亲，请输入手机号和密码！')
        return
      }
      if (!this.loginForm.smsCode) {
        this.$message.error('亲，请输入短信验证码！')
        return
      }
      if (this.loginForm.pwd.length < 6) {
        this.$message.error(
          '密码不符合要求：大小写、数字、特殊符号，至少有3种且6位以上！'
        )
        return
      }
      if (!isPwd(this.loginForm.pwd)) {
        this.$message.error(
          '亲，您的密码不符合要求：密码至少6位，包含大小写字母、数字！'
        )
        return
      }

     

      let post = this.loginForm

      let url = `${REPORT_API}/api/account/userRegister`
      if (this.role == 1) {
        url = `${LOGIN_API}/customer/api/userRegister`
      }
      this.$axios.post(url, post).then((res) => {
        if (this.role == 1) {
          if (res.data.errno == 0) {
            this.$message.success('注册成功！')
            this.goBackLogin()
          } else {
            this.$message.error(res.data.errmsg)
          }
        } else {
          if (res.data.code == 0) {
            this.$message.success('注册成功，请继续完善企业信息！')
            const hr_token = JSON.stringify({
              token: res.data.data.kao_token,
              finish: 0,
              mobile: this.loginForm.mobile,
            })
            document.cookie =
              'hr_token=' + hr_token + '; max-age=' + 60 * 60 * 12 + '; path=/;'
            this.$router.push({
              path: '/register/compInfo',
              query: { backURL: this.$route.query.backURL },
            })
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.password-box {
  width: 315px;
  margin: 0px auto 0px;
  .title {
    font-size: 20px;
    font-weight: 300;
    text-align: center;
    padding: 0px 0px 15px;
  }
  .input {
    padding: 10px 0px;
  }
  .yanzm {
    position: relative;
    .sendYanzm {
      position: absolute;
      top: 10px;
      right: 15px;
      color: #29bdb9;
      &.is-disabled {
        color: #999;
      }
    }
  }

  .user-reg {
    padding: 10px 0px;
    text-align: center;
    font-size: 14px;
    a {
      cursor: pointer;
      font-size: 14px;
    }
  }
  .viewDetail {
    font-size: 11px;
    padding: 15px 0px;

    a {
      color: #29bdb9;
      cursor: pointer;
    }
  }
}
</style>
<style>
.el-checkbox__inner {
  border-color: #29bdb9 !important;
  color: #29bdb9 !important;
}
.el-checkbox__label {
  font-weight: 400;
}
.reg-box .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #29bdb9 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/account/model/user-reg.vue